import { render, staticRenderFns } from "./ShipmentDashboardItemPage.vue?vue&type=template&id=ac2dbec8&scoped=true&"
import script from "./ShipmentDashboardItemPage.vue?vue&type=script&lang=js&"
export * from "./ShipmentDashboardItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDashboardItemPage.vue?vue&type=style&index=0&id=ac2dbec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2dbec8",
  null
  
)

export default component.exports